export default "/images/vendor/flag-icon-css/flags/1x1/tl.svg?c7a146dc0d916983f8dd11f2982c0ed9";